import { Box } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { IFeedTableProps } from '../../models/IFeed'
import FactTimeValue from './FactTimeValue'
import { COLORS } from '../../styles/colors'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'

const PlanNudgeTable = (props: IFeedTableProps) => {
	return (
		<Box sx={{ pt: '24px' }}>
			<TableContainer sx={{ p: '12px 18px 12px 16px' }}>
				<Table
					sx={{
						minWidth: 650,

						[`& .${tableCellClasses.root}`]: {
							borderBottom: 'none',
						},
					}}
					aria-label='simple table'
				>
					<TableHead>
						<TableRow
							sx={{ borderBottom: `1px solid ${COLORS.secondaryFontOpacity}` }}
						>
							<TableCell
								align='left'
								sx={{ paddingLeft: '8px', textAlign: 'left' }}
							>
								<TypographySecondary>Группа</TypographySecondary>{' '}
							</TableCell>
							<TableCell align='left'>
								<TypographySecondary>Плановое время</TypographySecondary>{' '}
							</TableCell>
							<TableCell align='left'>
								<TypographySecondary>
									Фактическое время
								</TypographySecondary>{' '}
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.groupsArray.map(el => (
							<TableRow key={el.group.id} sx={{}}>
								<TableCell
									component='th'
									scope='row'
									align='left'
									sx={{ width: '350px', paddingLeft: '8px' }}
								>
									<Box display='flex' flexDirection='row' alignItems='baseline'>
										{el.group.title}
										<TypographySecondary sx={{ pl: '4px' }}>
											{el.group.barn.title}
										</TypographySecondary>
									</Box>
								</TableCell>
								<TableCell align='left' sx={{ pl: '40px', width: '300px' }}>
									{el.plan_time ? el.plan_time : '00:00'}
								</TableCell>
								<TableCell align='left'>
									<FactTimeValue
										factDt={el.fact_dt}
										planTime={el.plan_time}
										date={props.feedPlanDate}
										deviation={props.deviation}
									/>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}

export default PlanNudgeTable
